<crm-single-select
  dataKey="name"
  [options]="taxations"
  [(selectedItem)]="selectedTaxation"
  (selectedItemChange)="selectedTaxationChange.emit($event)"
  [isTemplateCombined]="true"
  [filter]="false"
  [disabled]="disabled"
  [class]="class"
  [styleClass]="styleClass">
  <ng-template
    #itemTemplate
    let-taxation="item">
    <div>
      <div>{{ taxation.value | taxationTypeName }}</div>
      <div class="text-sm text-400">{{ taxation.value | taxationTypeDescription }}</div>
    </div>
  </ng-template>
</crm-single-select>
